import * as MUI from '@mui/material';

const CounterLinearProgress = MUI.styled(MUI.LinearProgress)(({theme}) => ({
    height: 8,
    borderRadius: 4,
    backgroundColor: theme.palette.grey[200],
    ...theme.applyStyles('dark', {
      backgroundColor: theme.palette.grey[800],
    })
}));

const TarifCounters = ({counters}) => {
    
    const counterTypes = {
        'call': 'Звонки',
        'data': 'Интернет',
        'msg': 'SMS'
    };

    const counterUnits = {
        '257': 'МБ',
        '355': 'мин',
        '796': 'шт'
    };

    // Группируем счетчики по типу для данной группы
    const countersByType = Object.values(Object.groupBy(
        counters,
        ({type}) => type
    ));

    return (
    <MUI.Grid container spacing={3} sx={{ mb: 3 }}>
        {countersByType.map((counterGroup) => {
            // Суммируем счетчики одного типа
            const counter = counterGroup.reduce((group, counter) => {
                if (!group.max_value) {
                    group = counter;
                } else {
                    if (counter.max_value) {
                        group.current_value += counter.current_value;
                        group.max_value += counter.max_value;
                    }
                }
                return group;
            });

            const groupName = counterTypes[counter.type] || counter.type;
            const value = counter.current_value || 0;
            const maxValue = counter.max_value || value;
            const progress = (value / maxValue) * 100;
            const unit = counterUnits[counter.unit] || '';
            
            let color = "success";
            if (progress <= 30) color = "warning";
            if (progress <= 10) color = "error";

            return (
                <MUI.Grid item xs={12} sm={4}>
                    <MUI.Box>
                        <MUI.Box display="flex" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
                            <MUI.Typography variant="body1" sx={{ fontWeight: 'medium', color: 'text.primary' }}>
                                {groupName}
                            </MUI.Typography>
                        </MUI.Box>

                        <MUI.Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1, color: 'text.primary' }}>
                            {Math.round(value)} из {maxValue}
                            <MUI.Typography component="span" variant="body1" color="text.secondary" sx={{ ml: 1 }}>
                                {unit}
                            </MUI.Typography>
                        </MUI.Typography>

                        <CounterLinearProgress
                            variant="determinate"
                            value={progress}
                            color={color}
                        />
                    </MUI.Box>
                </MUI.Grid>
            );
        })}
    </MUI.Grid>);

}

export default TarifCounters;
